import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { NavLinkType } from '../../type/navlink.types';
import AppHeader from './header/header.component';
import AppSidebar from './sidebar/sidebar.component';
import { Home } from 'tabler-icons-react';

function OnboardingLayout() {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const navLinkProps: NavLinkType[] = [
    {
      order: 1,
      link: '/onboarding/activate',
      label: 'Onboarding',
      icon: Home,
    },
  ];

  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <AppShell
        styles={{
          main: {
            background:
              theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
            paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
          },
        }}
        navbarOffsetBreakpoint='md'
        asideOffsetBreakpoint='md'
        fixed
        header={<AppHeader opened={opened} setOpened={setOpened} />}
        navbar={
          <AppSidebar navLinkProps={navLinkProps} opened={opened} hideSidebar />
        }
      >
        <Outlet />
      </AppShell>
    </MantineProvider>
  );
}

export default OnboardingLayout;
